import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { LoadingErrorMask } from '@cmd/ui-components';
import { useWindow } from '@cmd/ui-utilities';
import useRenderComponent from './useRenderComponent';
import './LogiComponent.scss';
const LogiComponent = ({ componentConfig, dateRange, orgId, }) => {
    const { cmdContainer: { environment, }, } = useWindow();
    const componentElementId = `logi-embed-component-${componentConfig.dashboardId}`;
    const { componentLoading, componentError, } = useRenderComponent(componentConfig, componentElementId, dateRange, environment, orgId);
    return (_jsxs(_Fragment, { children: [_jsx(LoadingErrorMask, { error: !!componentError, isLoading: componentLoading }), _jsx("div", { className: "logi-component", id: componentElementId })] }));
};
export default LogiComponent;
